import { createSlice } from "@reduxjs/toolkit";

/** localStorage key for the user's preferred streaming service slug */
export const SERVICE_SELECTED_STORAGE_KEY = "ms1-preferred-streaming-service";

const readStoredService = () => {
  try {
    if (typeof window === "undefined" || !window.localStorage) return null;
    const raw = window.localStorage.getItem(SERVICE_SELECTED_STORAGE_KEY);
    if (raw == null) return null;
    const trimmed = String(raw).trim();
    return trimmed || null;
  } catch {
    // Private mode / blocked storage
    return null;
  }
};

const writeStoredService = (slug) => {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    if (slug == null || String(slug).trim() === "") {
      window.localStorage.removeItem(SERVICE_SELECTED_STORAGE_KEY);
      return;
    }
    window.localStorage.setItem(SERVICE_SELECTED_STORAGE_KEY, String(slug));
  } catch {
    // ignore quota / private mode
  }
};

function InitState() {
  return {
    // Hydrate from browser so the last choice survives reloads
    serviceSelected: readStoredService(),
  };
}

export const musicPlayerSlice = createSlice({
  name: "musicPlayer",
  initialState: InitState(),
  reducers: {
    updateServiceSelected: (state, action) => {
      const next = action.payload == null ? null : String(action.payload);
      state.serviceSelected = next;
      writeStoredService(next);
    },
  },
});

export const musicPlayerActions = musicPlayerSlice.actions;

export default musicPlayerSlice.reducer;
